import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Table,
  Badge,
  InputGroup,
  Spinner,
  Container,
  Modal,
} from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Cookies from "es-cookie";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import { components } from 'react-select';
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { color } from "highcharts";

const styles = {
  page: {
    // background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
    minHeight: "100vh",
    padding: "28px 24px",
  },
  statCard: {
    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    borderRadius: 16,
    padding: "20px 24px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 4px 20px rgba(99,102,241,0.3)",
    marginBottom: 24,
  },
  statLabel: { fontSize: 13, opacity: 0.85, marginBottom: 4, fontWeight: 500 },
  statValue: { fontSize: 36, fontWeight: 800, lineHeight: 1 },
  statIcon: {
    fontSize: 36,
    background: "rgba(255,255,255,0.2)",
    borderRadius: 12,
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
    border: "none",
    color: "#000",
    marginBottom: 24,
    overflow: "hidden",
  },
  cardHeader: {
    border: "1px solid #e5e7eb",
    background: "rgba(250, 251, 255, 1)",
    color: "#000",
    padding: "18px 24px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  cardHeaderTitle: {
    color: "#000",
    fontWeight: 700,
    fontSize: 17,
    margin: 0,
  },
  cardHeaderIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "rgb(224,231,255)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6366f1",
    fontSize: 14,
  },
  cardBody: { padding: "22px 24px" },
  label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" },
  input: {
    borderRadius: 10,
    border: "1.5px solid #e5e7eb",
    padding: "9px 14px",
    fontSize: 14,
    color: "#1f2937",
    background: "#f9fafb",
    transition: "border-color 0.2s",
    width: "100%",
  },
  addBtn: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    border: "none",
    borderRadius: 10,
    padding: "9px 20px",
    fontWeight: 700,
    fontSize: 14,
    color: "#fff",
    width: "100%",
    boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
    cursor: "pointer",
  },
  cancelBtn: {
    background: "#f3f4f6",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 600,
    fontSize: 12,
    color: "#6b7280",
    cursor: "pointer",
  },
  idBadge: {
    // background: "linear-gradient(135deg, #dbeafe, #ede9fe)",
    color: "#000",
    // borderRadius: 20,
    // padding: "3px 12px",
    // fontWeight: 700,
    // fontSize: 12,
    // display: "inline-block",
    // border: "1px solid #c7d2fe",
  },
  phaseName: { fontWeight: 600, color: "#1f2937" },
  standardPill: {
    // background: "#f0fdf4",
    color: "#000",
    // borderRadius: 20,
    // padding: "3px 12px",
    // fontWeight: 600,
    // fontSize: 12,
    // display: "inline-block",
    // border: "1px solid #bbf7d0",
  },
  yearPill: {
    // background: "#fff7ed",
    color: "#000",
    // borderRadius: 20,
    // padding: "3px 12px",
    // fontWeight: 600,
    // fontSize: 12,
    // display: "inline-block",
    // border: "1px solid #fed7aa",
  },
  editBtn: {
    background: "linear-gradient(135deg, #f59e0b, #d97706)",
    border: "none",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 600,
    fontSize: 12,
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
  },
  countChip: {
    background: "linear-gradient(135deg, #ede9fe, #dbeafe)",
    color: "#4f46e5",
    borderRadius: 20,
    padding: "4px 14px",
    fontWeight: 700,
    fontSize: 13,
    border: "1px solid #c7d2fe",
  },
};

const GET_EXAM_PHASES = gql`
  query getExamPhases($institute_id: Int!) {
    getExamPhases(institute_id: $institute_id) {
      id
      exam_phase
      exam_standard_id
      exam_standard_name
      academic_year_id
      academic_year
    }
  }
`;

const ADD_EXAM_PHASE = gql`
  mutation addExamPhase(
    $exam_phase: String!
    $exam_board_id: Int!
    $institute_id: Int!
    $academic_year_id: Int!
  ) {
    addExamPhase(
      exam_phase: $exam_phase
      exam_board_id: $exam_board_id
      institute_id: $institute_id
      academic_year_id: $academic_year_id
    )
  }
`;

const UPDATE_EXAM_PHASE = gql`
  mutation updateExamPhase($id: Int!, $exam_phase: String!) {
    updateExamPhase(id: $id, exam_phase: $exam_phase)
  }
`;

class ExamTypes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      examTypeName: "",
      selectedAcademicYear: "",
      selectedExamBoard: "",
      selectedExamPhase: "",
      filterExamPhase: "",
      filterExamStandard: "",
      editingPhaseId: null,
      editingPhaseName: "",
      isSubmitting: false,
      filterAcademicYear: "0",
      filterExamBoard: "",
      showEditModal: false,
    };
  }

  componentDidMount() {
    const years = this.props.getYears;
    if (years?.length) {
      this.setState({ selectedAcademicYear: String(years[0].id) });
    }
  }

  componentDidUpdate(prevProps) {
    const years = this.props.getYears;
    const prevYears = prevProps.getYears;
    if (years?.length && !prevYears?.length) {
      this.setState((prev) => ({
        selectedAcademicYear: prev.selectedAcademicYear || String(years[0].id),
      }));
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "filterAcademicYear") {
      this.setState({ filterExamBoard: "" });
    }
    this.setState({ [name]: value });
  };

  handleSelectChange = (name, value) => {
    if (name === "filterAcademicYear") {
      this.setState({ filterExamBoard: "" });
    }
    this.setState({ [name]: String(value) });
  };

  handleAddExamPhase = async () => {
    const { examTypeName, selectedExamBoard, selectedAcademicYear } =
      this.state;

    if (!examTypeName || !selectedExamBoard || !selectedAcademicYear) {
      toast.error("Please fill all fields");
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const response = await this.props.mutate({
        variables: {
          exam_phase: examTypeName,
          exam_board_id: parseInt(selectedExamBoard),
          institute_id: parseInt(Cookies.get("institutionid")),
          academic_year_id: parseInt(selectedAcademicYear),
        },
      });


      if (response.data.addExamPhase) {
        toast.success("Exam Phase added successfully!");
        const defaultYear = String(this.props.getYears?.[0]?.id || "");
        this.setState({
          examTypeName: "",
          selectedAcademicYear: defaultYear,
          selectedExamBoard: "",
          selectedExamPhase: "",
          isSubmitting: false,
        });
        this.props.getExamPhasesQuery.refetch();
      }
    } catch (error) {
      console.log("response", error);
      console.error("Error adding exam phase:", error);
      toast.error(
        error.message || "Something went wrong"
      );
      this.setState({ isSubmitting: false });
    }
  };

  handleEditPhase = (phase) => {
    this.setState({
      showEditModal: true,
      editingPhaseId: phase.id,
      editingPhaseName: phase.exam_phase,
    });
  };

  handleClose = () => {
    this.setState({
      showEditModal: false,
      editingPhaseId: null,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editingPhaseId: null,
      editingPhaseName: "",
    });
  };

  handleSaveEdit = async () => {
    if (!this.state.editingPhaseName) {
      toast.error("Please enter phase name");
      return;
    }
    this.setState({ isSubmitting: true });
    try {
      const response = await this.props.updateMutate({
        variables: {
          id: this.state.editingPhaseId,
          exam_phase: this.state.editingPhaseName,
        },
      });

      if (response.data.updateExamPhase) {
        toast.success("Phase updated successfully!");
        this.setState({ isSubmitting: false, showEditModal: false, editingPhaseId: null });
        this.handleCancelEdit();
        this.props.getExamPhasesQuery.refetch();
      }
    } catch (error) {
      console.error("Error updating phase:", error);
      toast.error("Error updating phase");
      this.setState({ isSubmitting: false });
    }
  };

  getPhaseCountByType = (type) => {
    const phases = this.props.getExamPhasesQuery?.getExamPhases || [];
    return phases.filter((phase) =>
      phase.exam_phase.toUpperCase().startsWith(type.toUpperCase()),
    ).length;
  };

  getTotalPhaseCount = () => {
    return this.props.getExamPhasesQuery?.getExamPhases?.length || 0;
  };

  getFilteredPhases = () => {
    let phases = this.props.getExamPhasesQuery?.getExamPhases || [];

    const { filterAcademicYear, filterExamBoard } = this.state;

    if (filterAcademicYear && +filterAcademicYear !== 0) {
      phases = phases.filter(
        (phase) => +phase.academic_year_id === +filterAcademicYear
      );
    }

    if (filterExamBoard && +filterExamBoard !== 0) {
      phases = phases.filter(
        (phase) => +phase.exam_standard_id === +filterExamBoard
      );
    }

    return phases;
  };

  statusColor = (status) => {
    if (status === "Active") return "success";
    if (status === "Draft") return "warning";
    return "secondary";
  };

  handleLoadPhases = () => {
    if (this.state.selectedAcademicYear && this.state.selectedExamBoard) {
      this.props.getExamPhasesQuery.refetch({
        institute_id: parseInt(Cookies.get("institutionid")),
        exam_board_id: parseInt(this.state.selectedExamBoard),
        academic_year_id: parseInt(this.state.selectedAcademicYear),
      });
    } else {
      toast.error("Please select Academic Year and Standard first");
    }
  };


  articlecolumns = [
    {
      dataField: "index",
      text: "Sno",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerStyle: { width: "60px" },
      sort: false,
    },
    // {
    //   dataField: "id",
    //   text: "Phase ID",
    //   sort: true,
    //   formatter: (cell) => (
    //     <span style={styles.idBadge}>{cell}</span>
    //   ),
    // },
    {
      dataField: "exam_phase",
      text: "Phase Name",
      sort: true,
      formatter: (cell) => (
        <span style={styles.phaseName}>{cell}</span>
      ),
    },
    {
      dataField: "exam_standard_name",
      text: "Standard",
      sort: true,
      formatter: (cell) => (
        <span style={styles.standardPill}>{cell}</span>
      ),
    },
    {
      dataField: "academic_year",
      text: "Academic Year",
      sort: true,
      formatter: (cell) => (
        <span style={styles.yearPill}>{cell}</span>
      ),
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => (
        <button
          style={styles.editBtn}
          onClick={() => this.handleEditPhase(row)}
        >
          ✏ Edit
        </button>
      ),
    }
  ];

  render() {
    const filteredPhases = this.getFilteredPhases();
    return (
      <div style={styles.page}>
        {/* ===== Add Phase ===== */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.cardHeaderIcon}>
              <i className="fa fa-plus" />
            </div>
            <h5 style={styles.cardHeaderTitle}>Add Exam Type</h5>
          </div>

          <div style={styles.cardBody}>
            <Row className="g-3">
              {/* Exam Name */}
              <Col xs={12} md={4}>
                <div style={styles.label}>Exam Type Name</div>
                <input
                  style={styles.input}
                  placeholder="e.g. Term-I, FA1, SA2"
                  name="examTypeName"
                  value={this.state.examTypeName}
                  onChange={this.handleInputChange}
                />
              </Col>

              {/* Year */}
              <Col xs={12} sm={6} md={3}>
                <div style={styles.label}>Academic Year</div>
                <SelectDropDown
                  name="selectedAcademicYear"
                  placeholderName="Select Academic Year"
                  options={this.props.getYears.map((year) => ({ value: year.id, label: year.academic_year, id: year.id }))}
                  stateData={this.props.getYears.map((year) => ({ value: year.id, label: year.academic_year, id: year.id })).find((opt) => String(opt.value) === String(this.state.selectedAcademicYear)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              {/* Standard */}
              <Col xs={12} sm={6} md={3}>
                <div style={styles.label}>Standard</div>
                <SelectDropDown
                  name="selectedExamBoard"
                  placeholderName="Select Standard"
                  options={(this.props.getExamBoards || []).map((board) => ({ value: board.board_id, label: board.exam_board_name, id: board.board_id }))}
                  stateData={(this.props.getExamBoards || []).map((board) => ({ value: board.board_id, label: board.exam_board_name, id: board.board_id })).find((opt) => String(opt.value) === String(this.state.selectedExamBoard)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              {/* Button */}
              <Col xs={12} md={2} className="d-flex align-items-end">
                <button
                  style={{
                    ...styles.addBtn,
                    opacity: this.state.isSubmitting ? 0.7 : 1,
                  }}
                  onClick={this.handleAddExamPhase}
                  disabled={this.state.isSubmitting}
                >
                  {this.state.isSubmitting ? "Adding..." : "+ Add Phase"}
                </button>
              </Col>
            </Row>

            {/* ===== Registry ===== */}
            <div style={styles.card} className="mt-3">
              <div style={styles.cardHeader}>
                <div style={styles.cardHeaderIcon}>
                  <i className="fa fa-list" />
                </div>
                <h5 style={styles.cardHeaderTitle}>Exam Types</h5>
              </div>

              {/* Filters */}
              <div style={styles.cardBody}>
                <Row className="g-3">
                  <Col xs={12} sm={6} md={4}>
                    <div style={styles.label}>Academic Year</div>
                    <SelectDropDown
                      name="filterAcademicYear"
                      placeholderName="All Years"
                      isClearable={false}
                      options={[{ value: "0", label: "All Years", id: "0" }, ...this.props.getYears.map((year) => ({ value: year.id, label: year.academic_year, id: year.id }))]}
                      stateData={[{ value: "0", label: "All Years", id: "0" }, ...this.props.getYears.map((year) => ({ value: year.id, label: year.academic_year, id: year.id }))].find((opt) => String(opt.value) === String(this.state.filterAcademicYear)) || null}
                      handleChange={this.handleSelectChange}
                    />
                  </Col>

                  <Col xs={12} sm={6} md={4}>
                    <div style={styles.label}>Standard</div>
                    <SelectDropDown
                      name="filterExamBoard"
                      placeholderName="All Standards"
                      options={[{ value: "0", label: "All Standards", id: "0" }, ...(this.props.getExamBoards || []).map((board) => ({ value: board.board_id, label: board.exam_board_name, id: board.board_id }))]}
                      stateData={[{ value: "0", label: "All Standards", id: "0" }, ...(this.props.getExamBoards || []).map((board) => ({ value: board.board_id, label: board.exam_board_name, id: board.board_id }))].find((opt) => String(opt.value) === String(this.state.filterExamBoard)) || null}
                      handleChange={this.handleSelectChange}
                      isClearable={false}
                    />
                  </Col>

                  <Col xs={12} md={4} className="d-flex align-items-end">
                    <div style={styles.countChip}>
                      {filteredPhases.length} phase
                      {filteredPhases.length !== 1 ? "s" : ""}
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Table */}
              <Container fluid="md">
                {
                  filteredPhases?.length === 0 && this.state.isSubmitting ? (
                    <div className="py-4">
                      <style>
                        {`
                                                            @keyframes shimmerLoading {
                                                                0% { background-position: -1000px 0; }
                                                                100% { background-position: 1000px 0; }
                                                            }
                                                            .shimmer-line {
                                                                height: 20px;
                                                                margin-bottom: 15px;
                                                                background: #f6f7f8;
                                                                background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                                                                background-repeat: no-repeat;
                                                                background-size: 1000px 100%;
                                                                animation: shimmerLoading 1.5s infinite linear forwards;
                                                                border-radius: 4px;
                                                            }
                                                            .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                                                        `}
                      </style>
                      <div className="shimmer-line shimmer-header" style={{ width: '100%' }}></div>
                      <div className="shimmer-line" style={{ width: '100%' }}></div>
                      <div className="shimmer-line" style={{ width: '100%' }}></div>
                      <div className="shimmer-line" style={{ width: '100%' }}></div>
                      <div className="shimmer-line" style={{ width: '100%' }}></div>
                      <div className="shimmer-line" style={{ width: '80%' }}></div>
                    </div>
                  ) : (
                    <CardLessDataTableWithSearch
                      parentData={filteredPhases}
                      particlecolumns={this.articlecolumns}
                      name="hostel_attendance"
                    />
                  )
                }

              </Container>
            </div>
          </div>
        </div>



        {
          this.state.showEditModal && (
            <Modal
              show={this.state.showEditModal}
              onHide={this.handleClose}
              centered
            >
              <Modal.Header
                closeButton
                style={{
                  background:
                    "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
                  color: "#fff",
                  borderBottom: "none"
                }}
              >
                <Modal.Title
                  className="text-center"
                  style={{
                    width: "100%",
                    fontWeight: "700"
                  }}
                >
                  Mark Holiday
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                {/* Body */}
                <div style={{ padding: "24px" }}>

                  {/* Input */}
                  <div className="mb-4">

                    <label
                      style={{
                        fontWeight: "700",
                        color: "#374151",
                        marginBottom: "10px",
                        display: "block"
                      }}
                    >
                      Phase Name
                    </label>

                    <div
                    // style={{
                    //   position: "relative"
                    // }}
                    >
                      {/* <i
                        className="fa fa-bookmark"
                        style={{
                          position: "absolute",
                          top: "17px",
                          left: "15px",
                          color: "#6b7280",
                          fontSize: "15px"
                        }}
                      ></i> */}

                      <Form.Control
                        placeholder="e.g. Term-I, FA1, SA2"
                        value={this.state.editingPhaseName}
                        onChange={(e) =>
                          this.setState({
                            editingPhaseName: e.target.value
                          })
                        }
                      // style={{
                      //   height: "60px",
                      //   borderRadius: "14px",
                      //   border: "1px solid #dbe3f0",
                      //   paddingLeft: "42px",
                      //   fontSize: "15px",
                      //   fontWeight: "500",
                      //   boxShadow: "0 3px 10px rgba(0,0,0,0.05)"
                      // }}
                      />
                    </div>

                  </div>

                  {/* Buttons */}
                  <div
                    className="d-flex justify-content-end flex-wrap"
                    style={{
                      gap: "12px"
                    }}
                  >

                    <Button
                      onClick={this.handleClose}
                      style={{
                        background: "#fff",
                        color: "#374151",
                        border: "1px solid #d1d5db",
                        borderRadius: "12px",
                        padding: "10px 24px",
                        fontWeight: "600",
                        fontSize: "14px"
                      }}
                    >
                      <i className="fa fa-times mr-2"></i>
                      Cancel
                    </Button>

                    <Button
                      onClick={this.handleSaveEdit}
                      disabled={this.state.isSubmitting}
                      style={{
                        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        border: "none",
                        borderRadius: "12px",
                        padding: "10px 24px",
                        fontWeight: "700",
                        fontSize: "14px",
                        minWidth: "180px"
                      }}
                    >
                      {
                        this.state.isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm mr-2"></span>
                            Updating...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-check-circle mr-2"></i>
                            Update Phase
                          </>
                        )
                      }
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )
        }
      </div>
    );
  }
}


export default withRouter(
  compose(
    graphql(GET_EXAM_PHASES, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "getExamPhasesQuery",
    }),


    graphql(ADD_EXAM_PHASE, {
      name: "mutate",
    }),
    graphql(UPDATE_EXAM_PHASE, {
      name: "updateMutate",
    }),
  )(ExamTypes),
);
